import { render, staticRenderFns } from "./FinancialData.vue?vue&type=template&id=32c0de7f"
import script from "./FinancialData.vue?vue&type=script&lang=js"
export * from "./FinancialData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports